<script setup lang="ts">
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { RouterView, useRouter } from 'vue-router'
import type { RouteLocationRaw } from 'vue-router'
import useUser from '@/composables/useUser'
import AppDialog from '@/components/AppDialog.vue'

const router = useRouter()
const authStore = useAuthStore()
const { useGetUser } = useUser()

onMounted(async () => {
  if (authStore.currentUser) {
    try {
      await useGetUser()
      authStore.loadUser()

      authStore.loadRedirectRoute()
      if (authStore.redirectRoute) {
        await router.isReady()
        await router.replace(authStore.redirectRoute as RouteLocationRaw)
        authStore.clearRedirectRoute()
      }
    } catch {
      authStore.clearUser()
    }
  }

  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'NAVIGATE') {
        router.push(event.data.url as RouteLocationRaw)
      }
    })
  }
})
</script>

<template>
  <AppLayout>
    <RouterView />
  </AppLayout>
  <AppDialog />
</template>

<style scoped>
header {
  line-height: 1.5;
  max-height: 100vh;
}

.logo {
  display: block;
  margin: 0 auto 2rem;
}

nav {
  width: 100%;
  font-size: 12px;
  text-align: center;
  margin-top: 2rem;
}

nav a.router-link-exact-active {
  color: var(--color-text);
}

nav a.router-link-exact-active:hover {
  background-color: transparent;
}

nav a {
  display: inline-block;
  padding: 0 1rem;
  border-left: 1px solid var(--color-border);
}

nav a:first-of-type {
  border: 0;
}

@media (min-width: 1024px) {
  header {
    display: flex;
    place-items: center;
    padding-right: calc(var(--section-gap) / 2);
  }

  .logo {
    margin: 0 2rem 0 0;
  }

  header .wrapper {
    display: flex;
    place-items: flex-start;
    flex-wrap: wrap;
  }

  nav {
    text-align: left;
    margin-left: -1rem;
    font-size: 1rem;

    padding: 1rem 0;
    margin-top: 1rem;
  }
}
</style>
